<template>
    <div>
        <BreadCrumb :data="breadCrumb" />  
        <Table :fields="fields" :items="list" :filtered="filtered" type="List" :loading="loading" :limit="limit" :setLimit="setLimit" :page="page" 
         :setPage="setPage" :pageData="pageInfo" :actions="actions" :actionEvent="actionEvent" :goDetail="goDetail" :inputs="inputs" :search="search" :gSearch="gSearch"  />
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" :onComplete="complete" />
    
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import Table from "@/components/Table"
    import i18n from '@/plugins/i18n';
    import Modals from "./modals/"

     let breadCrumb = [
        { label: i18n.t('pages.account.name'), url: "/Accounts/List" },
    ]

       let fields = [ 
         { key: 'account_no', label: i18n.t('account.list.accountNo'),  keys: ['account_info', 'account', 'account_no'] },
         { key: 'PartNo', label: i18n.t('account.list.part'), keys:['PartNo'] },
         { key: 'name', label: i18n.t('account.list.name'), keys:['name']},
         { key: 'address', label: i18n.t('account.list.address'), keys:['address']},
         { key: 'dealer', label: i18n.t('account.list.dealer'), keys:['dealer'] },
         { key: 'account_type', type:'badge', label: i18n.t('account.list.type'), keys:['account_type', 'name'] },
         { key: 'active', label: i18n.t('account.list.state')},
         { key: 'expiredIn', type: "expiredIn", label: i18n.t('account.list.expireDate'), keys:['account_info', 'customer_sub', 'info', 'end_date']  },
         { key: 'actions', label: i18n.t('account.list.actions')}
    ]; 

     let inputs = [ 
        { key: 'account-no', label: i18n.t('account.form.accountCode'), type: "String", checked: false, val:""},
        { key: 'account-type', label: i18n.t('account.form.type'), type: "String", checked: false, val:""},
        { key: 'name', label: i18n.t('account.form.name'), type: "String", checked: false, val:""},
        { key: 'part-no', label: i18n.t('account.form.part'), type: "String", checked: false, val:""},
    ]; 

     let actions = [
        {key: 'detail', text: i18n.t('account.list.detail')},
        {key: 'copy', text: i18n.t('account.list.copy')},
        {key: 'part', text: i18n.t('account.list.createPart')},
        {key: 'active', text: i18n.t('account.list.active'), state: 1},
        {key: 'passive', text: i18n.t('account.list.passive'), state: 0},
        {key: 'cancel', text: i18n.t('account.list.cancel'), state: 2},
        {key: 'delete', text: i18n.t('account.list.delete')},
        {key: 'createServiceForm', text: i18n.t('customer.list.serviceForm')}
    ]

    let filtered = ['account_no', "PartNo", 'name', 'address', 'dealer', 'account_type', 'active', 'expiredIn', 'actions']; 

    export default {
        name: 'AccountList',
        created: async function(){
            await this.$store.dispatch('account_get', this.params)
        },
        computed:{
            fetchData(){
                this.$store.dispatch('account_get', this.params)
            },
            message(){
                return  this.$store.getters.getAccountStatus
            },
            loading(){
                return this.$store.getters.getAccountLoading
            },
            list(){
                return this.$store.getters.getAccounts
            },
            pageInfo(){
                return this.$store.getters.getAccountPageInfo
            }
        },
        data: function(){
            return{
                breadCrumb, fields, filtered, limit:10, page: 1, offset: 0, actions, modalOpen: false,
                modalProps: {}, currentForm:"Account", modalName: "", dismissCountDown: 0, inputs,
                params:{
                    limit:10,
                    offset: 0,
                }
            }
        },
        watch:{
            limit(val){
                this.params['limit'] = val
                this.$store.dispatch('account_get', this.params)
            },
            offset(val){
                 this.params['offset'] = val
                 this.$store.dispatch('account_get', this.params)
            }
        },
        components:{
            BreadCrumb, Table, Modals
        },
        methods:{
            search(){
                console.log(inputs)
                this.inputs.map((input)=>{
                    input.checked ? this.params[input.key] = input.val : delete this.params[input.key]
                })
                this.$store.dispatch('account_get', this.params)
            },
            gSearch(data){
                data.length > 0 ? this.params['search'] = data : delete this.params['search']
                this.$store.dispatch('account_get', this.params)
            },
            goDetail(item){
                this.$router.push( { path: '/Accounts/'+item.account_info.customer_id+'/'+item.ID+'/edit' })
            },
            complete(){
                this.dismissCountDown = 5
                this.$store.dispatch('account_get', this.params)
            },
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            setLimit:function(limit){
                this.limit = limit
            },
            setPage:function(page){
                if(page > 0){
                    this.page = page
                    this.offset = ((page-1) * this.limit)
                }
            },
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
            actionEvent: async function(key, data){
                switch(key){
                    case 'detail':
                        this.$router.push( { path: '/Accounts/'+data.ID })
                        break;
                    case 'active':
                        this.openModal(true, 'SetState', {...data, state:1, type: 'state'})
                        break;
                    case 'passive': 
                        this.openModal(true, 'SetState', {...data, state:0, type: 'state'})
                        break;
                    case 'cancel':
                        this.openModal(true, 'SetState', {...data, state:2, type: 'state'})
                        break;
                    case 'delete':
                        this.openModal(true, 'delete', data)
                        break;
                    case 'copy':
                        this.openModal(true, 'SetState', {...data, type:'copy'})
                        break;
                    case 'part':
                        this.openModal(true, 'SetState', {...data, type:'part'})
                        break;
                    case 'createServiceForm':
                        this.openModal(true, 'createServiceForm', {info: data})
                        break;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/List.vue